<template>
    <div class="defaultorderstatus">
            <div class="defaultOrderStatusCon">
                <!-- <div class="statusSideTop" >
                    <div class="statusSetTitle">
                        <span>设置</span>
                    </div>
                    <el-scrollbar style="height: 100%;margin-right: 0" class="textScroller">
                        <div style="width: 150px">
                            <div class="statusSideTitle" @click="fieldClick" :class="{statusActive:this.$route.name==='/fieldmanagement'}">字段管理</div>
                            <div class="statusSideTitle" @click="orderTemplateClick" :class="{statusActive:this.$route.name==='/workordertemlate'}" >工单模板</div>
                            <div class="statusSideTitle" @click="defaultInfoClick" :class="{statusActive:this.$route.name==='/defaultinfo'}">自定义状态</div>
                        </div>
                    </el-scrollbar>
                </div> -->
                <div class="main">
                        <router-view />
                </div>
            </div>
    </div>
</template>

<script>
    export default {
        name: "DefaultOrderStatus",
        data(){
            return{
                isShow:0
            }
        },
        methods:{
            fieldClick(){
                this.$router.push('/fieldmanagement')
                this.isShow=0
            },
            orderTemplateClick(){
                this.$router.push('/workordertemlate')
                this.isShow=1
            },
            defaultInfoClick(){
                this.$router.push('/defaultinfo')
                this.isShow=2
            },
            accountManageClick(){
                this.$router.push('/accountManage')
                this.isShow=3
            }

        },
        deactivated() {
            console.log('aaa')
        }
    }
</script>

<style scoped lang="less">
  @import ".././../assets/less/defaultorderstatus/defaultorderstatus";
.textScroller{
    .el-scrollbar__wrap{
        margin: 0;
    }
    .el-scrollbar__view{

    }
}
</style>